import AuthenticationProvider from '@my-pages/features/auth/providers/AuthenticationProvider';
import { PropsWithChildren } from 'react';
import ToastProvider from 'taf-shared/features/toasts/contexts/ToastProvider';

const ApplicationProvider = ({ children }: PropsWithChildren) => {
    return (
        <ToastProvider>
            <AuthenticationProvider>{children}</AuthenticationProvider>
        </ToastProvider>
    );
};
export default ApplicationProvider;
